import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { SuiContainer, SuiLabel } from '@splashthat/sui';

import { classNames } from 'utils/classNames';

const BASE_CLASS_NAME = 'WorkspaceSidebarSection';

/**
 * Renders a bold label if one is given.
 * Applies vertical padding to its content.
 * Applies a bottom border to separate multiple WorkspaceSidebarSections.
 */
class WorkspaceSidebarSection extends Component {
    static propTypes = {
        label: PropTypes.string,
        children: PropTypes.node,
        className: PropTypes.string,
    };

    static defaultProps = {
        label: '',
        className: null,
        children: [],
    };

    render() {
        const { label } = this.props;

        const className = classNames({
            [BASE_CLASS_NAME]: true,
            [this.props.className]: !!this.props.className,
        });

        return (
            <SuiContainer className={className}>
                {label ? <SuiLabel className={`${BASE_CLASS_NAME}__label`}>{label}</SuiLabel> : null}

                {this.props.children}
            </SuiContainer>
        );
    }
}

export default WorkspaceSidebarSection;
